var map = {
	"./doc.svg": "d5c0",
	"./excel.svg": "75fe",
	"./file.svg": "002a",
	"./folder-gray.svg": "0689",
	"./folder-red.svg": "9863",
	"./image.svg": "da27",
	"./logo.svg": "e347",
	"./np_folder.svg": "58c1",
	"./pdf.svg": "5fe9",
	"./ppt.svg": "3175",
	"./random.svg": "e974"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";